"use client";

import type { PropsWithChildren } from "react";

import type { UserForClient } from "@/lib/supabase/repository/user";

import { userContext } from "@/hooks/use-user";

export function UserProvider({
  user,
  children,
}: PropsWithChildren<{ user: UserForClient | null }>) {
  return <userContext.Provider value={user}>{children}</userContext.Provider>;
}
